import axios from 'axios'
import { GetCorporateResponse } from '../../types/corporate'

export const getCorporate = async (
  projectId: number
): Promise<GetCorporateResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const response = await axios.get(`${backendUrl}/n8n/mavis/corporate`, {
      params: {
        project_id: projectId
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return (response.data as unknown) as GetCorporateResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
